import { Box, Typography } from "@mui/material";
import { BlackButtonComponent } from "../../components";
import useKYCScreen from "./hooks/kycScreen";
import { useState } from "react";
import OtpDialog from "../auth/otp-verifiction";
import KYCDetailsForm from "./../../components/shared/kyc-details-form/kyc-details-form";
import { toast } from "react-toastify";
import { verifyAadharOtp } from "services/otpService";
import { useDispatch, useSelector } from "react-redux";
import { updateHostKyc, updateHostState } from "slice/hostSlice";
import { RootState } from "store";
import { appendDetails } from "services/MerchantHostApi";
import { containsPropertyHost, getChangedFields } from "utils/index";
import { useNavigate } from "react-router";

const KYCDetailsScreen = () => {
  const { formik, closeOtpDialog, openOtpDialog, showOtpDialog } =
    useKYCScreen();
  const [requestId, setRequestId] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState(formik.values);

  const isAadharVerified = useSelector(
    (state: RootState) => state.hostForm.hostKYC.isAdharVerified
  );
  const aadharDetails = useSelector(
    (state: RootState) => state.hostForm.hostKYC
  );
  const userDetails = useSelector(
    (state: RootState) => state.appLayout.userDetails
  ) as any;

  const handleOtpVerification = async (otp: string) => {
    if (!otp.trim()) {
      toast.error("OTP cannot be empty. Please enter a valid OTP.");
      return;
    }

    if (requestId === null) {
      toast.error("Request ID is missing. Please try again.");
      return;
    }

    setLoading(true);

    try {
      const response = await verifyAadharOtp(
        formik.values.adharNumber,
        otp,
        requestId
      );

      if (response?.status === 1 && response?.message === "Success") {
        toast.success("OTP verified successfully!");

        const verifiedDetails = {
          isAdharVerified: true,
          aadharNumber: formik.values.adharNumber,
          ...response.result,
        };

        dispatch(updateHostKyc(verifiedDetails));
        closeOtpDialog();
      } else {
        toast.error(response?.message || "Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      toast.error("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!formik.isValid) {
      toast.error("Please fill in all required fields.");
      return;
    }
    if (!isAadharVerified) {
      toast.error("Please verify your Aadhar number before submitting.");
      return;
    }
    const changedFields = getChangedFields(initialValues, formik.values);

    try {
      setLoading(true);
      const data: any = {
        hostKYC: {
          ...aadharDetails,
          panNumber: formik.values.panNumber,
          updatedItems: changedFields,
        },
      };

      const val = containsPropertyHost(userDetails, "hostKYC");

      if (val === "UPDATE") {
        data.kycStatus = "UPDATE";
      } else if (val === "TRUE") {
        data.kycStatus = "COMPLETED";
      }

      const response = await appendDetails(
        userDetails.userType,
        userDetails.userId,
        data
      );

      if (response?.message === "Item updated successfully") {
        toast.success("KYC details updated successfully!");
        dispatch(updateHostState(response?.updatedItem));
        setInitialValues(formik.values);
        window.location.reload();
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error(
        "Failed to update details. Please check your network and try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" flexDirection="column" rowGap={2}>
      <Box>
        <Typography variant="h5" mb={2}>
          KYC
        </Typography>
      </Box>

      <KYCDetailsForm
        formik={formik}
        isOtpVerified={isAadharVerified}
        setIsOtpDialogOpen={openOtpDialog}
        setRequestId={setRequestId}
      />

      {showOtpDialog && (
        <OtpDialog
          handleClose={closeOtpDialog}
          handleVerification={handleOtpVerification}
        />
      )}
      <Box textAlign="right" display="flex" justifyContent="end" columnGap={2}>
        <BlackButtonComponent
          onClick={handleSubmit}
          btnText={loading ? "Submitting..." : "Submit"}
          sx={{ padding: "6px 40px" }}
          disabled={loading}
        />
      </Box>
    </Box>
  );
};

export default KYCDetailsScreen;
